// src/i18n/es/system.ts

const system = {
  title: 'Información del Sistema',
  description: 'Estado del entorno de ejecución, almacenamiento y tareas programadas, para soporte y diagnóstico.',
  refresh: 'Actualizar',
  lastUpdated: 'Última actualización',

  cards: {
    overview: 'Resumen',
    application: 'Aplicación',
    database: 'Base de Datos',
    statistics: 'Estadísticas',
    secrets: 'Configuración y Secrets',
    logging: 'Registro',
    services: 'Servicios Externos y Salud',
    jobs: 'Tareas en Segundo Plano',
  },

  // Categorías genéricas del proveedor de base de datos — la interfaz nunca
  // nombra el motor concreto, solo su tipo.
  database: {
    categoryRelational: 'Relacional',
    categoryDocument: 'Orientada a documentos',
    categoryOther: 'Otro',
  },

  fields: {
    version: 'Versión',
    environment: 'Entorno',
    uptime: 'Tiempo activo',
    serverTime: 'Hora del Servidor',
    machineName: 'Máquina',
    processorCount: 'Procesadores',
    osDescription: 'Sistema Operativo',
    dotnetVersion: 'Versión del entorno de ejecución',
    hangfireServerName: 'Servidor Hangfire',
    isConnected: 'Conexión',
    provider: 'Proveedor',
    pendingMigrations: 'Migraciones Pendientes',
    appliedMigrations: 'Migraciones Aplicadas',
    databaseSize: 'Tamaño de la BD',
    totalDevices: 'Total Dispositivos',
    onlineDevices: 'Dispositivos Online',
    totalHotels: 'Instalaciones',
    totalGroups: 'Grupos',
    totalEventsToday: 'Eventos Hoy',
    totalCheckInsToday: 'Check-ins Hoy',
    activeAlerts: 'Alertas Activas',
  },

  secrets: {
    configured: 'Configurado',
    notConfigured: 'No configurado',
    required: 'Obligatorio',
    optional: 'Opcional',
    allConfigured: 'Todos los secrets obligatorios están configurados',
    missingRequired: '%{count} secret(s) obligatorio(s) sin configurar',
    // Sustituciones genéricas para un nombre de tecnología que el nombre de
    // un secreto pueda traer literal desde la API (nunca se muestra tal cual).
    neutralTerms: {
      identityProvider: 'Proveedor de identidad',
      database: 'Base de datos',
      logServer: 'Servidor de registros',
    },
  },

  logging: {
    sectionLabel: 'Servidor de registros',
    seqEnabled: 'Registro centralizado activado',
    seqUrl: 'URL del servidor de registros',
    seqApiKey: 'Clave de API del servidor de registros',
    s3Enabled: 'Almacenamiento S3 Habilitado',
    s3Url: 'URL Servicio S3',
    s3Bucket: 'Bucket S3',
    s3Credentials: 'Credenciales S3',
    installationId: 'ID de Instalación',
    appName: 'Nombre de la Aplicación',
    seqFilter: 'Filtro de registros',
    copyFilter: 'Copiar filtro de registros',
    filterCopied: 'Filtro de registros copiado al portapapeles',
    filterHelp: 'Utilice este filtro en el servidor de registros para ver los registros de esta aplicación',
  },

  services: {
    name: 'Servicio',
    url: 'URL',
    status: 'Estado',
    latency: 'Latencia',
    reachable: 'Accesible',
    unreachable: 'No accesible',
    recheck: 'Verificar',
  },

  health: {
    name: 'Verificación',
    status: 'Estado',
    description: 'Descripción',
    duration: 'Duración',
    healthy: 'Saludable',
    degraded: 'Degradado',
    unhealthy: 'No saludable',
  },

  jobs: {
    name: 'Nombre',
    queue: 'Cola',
    schedule: 'Programación',
    lastExecution: 'Última Ejecución',
    nextExecution: 'Próxima Ejecución',
    lastDuration: 'Duración',
    status: 'Estado',
    actions: 'Acciones',
    trigger: 'Ejecutar ahora',
    triggerSuccess: 'Tarea lanzada correctamente',
    triggerError: 'Error al lanzar la tarea',
    neverExecuted: 'Nunca ejecutada',
    description: 'Descripción',
  },

  status: {
    connected: 'Conectado',
    disconnected: 'Desconectado',
    healthy: 'Saludable',
    degraded: 'Degradado',
    unhealthy: 'No saludable',
    succeeded: 'Completado',
    failed: 'Fallido',
    processing: 'Procesando',
    unknown: 'Desconocido',
  },
};

export default system;
